// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__3V9Zq","modalForm":"UpgradeEpcsModal_modalForm__3GYlo","modalFooter":"UpgradeEpcsModal_modalFooter__GFcQK"};